import React from 'react'

import { connect } from 'react-redux'

import SettingsMenu from './SettingsMenu'
import General from './modules/General'
import Calendar from './modules/calendar/Calendar'
import DailyEmails from './modules/dailyEmails/DailyEmails'
import Materials from './modules/materials/Materials'
import API from './modules/API'
import APIKeys from './modules/apiKeys/APIKeys'
import InvoiceItems from './modules/invoiceItems/InvoiceItems'
import CompanyLogo from './modules/companyLogo/CompanyLogo'

class Settings extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectionId: 'general'
    }
  }

  handleOptionClicked = selectionId => {
    this.setState({ selectionId })
  }

  getSelectedComponent = () => {
    switch (this.state.selectionId) {
      case 'general':
        return <General />
      case 'calendar':
        return <Calendar />
      case 'daily_emails':
        return <DailyEmails />
      case 'materials':
        return <Materials />
      case 'invoice_items':
        return <InvoiceItems />
      case 'company_logo':
        return <CompanyLogo />
      case 'api':
        return <API />
      case 'api_keys':
        return <APIKeys />
      default:
        return null
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.topbar}>Settings</div>
        <div style={styles.horizontalSeparator} />
        <div style={styles.main}>
          <SettingsMenu
            selectionId={this.state.selectionId}
            onOptionClicked={this.handleOptionClicked}/>
          <div style={styles.verticalSeparator} />
          <div style={styles.content}>
            { this.getSelectedComponent() }
          </div>
        </div>
      </div>
    )
  }

}

export default connect()(Settings)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  topbar: {
    fontSize: 24,
    paddingLeft: 25,
    paddingTop: 25,
    paddingBottom: 25,
    color: '#4a4a4a',
    border: 'inset 0 -1px 0 1px rgba(0, 0, 0, 0.05)',
    textAlign: 'left'
  },
  main: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#fff',
    flex: 1
  },
  content: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 64
  },
  verticalSeparator: {
    width: 1,
    backgroundColor: '#d8d8d8'
  },
  horizontalSeparator: {
    height: 2,
    backgroundColor: '#d8d8d8'
  }
}



// WEBPACK FOOTER //
// ./src/settings/Settings.js